import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";
import { ModalHeader, Textlink, StyledModal } from "../common/StyledComponents";

const AdminResetPasswordModal = (props) => {

  const [open, setOpen] = useState(props.open);
  const resetPassword = async (bool) => {
    setOpen(false);
    await props.resetPassword(props.userData, bool);
  };

  return (
    <StyledModal
      onClose={() => resetPassword(false)}
      onOpen={() => setOpen(true)}
      open={open}
      size="mini"
      style={{ position: "relative" }}
    >
      <ModalHeader regular>Reset Password ?</ModalHeader>
      <Modal.Content>
        <p>This cannot be undone, are you sure you want to reset password for this user?</p>
      </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={() => resetPassword(false)}>
          Cancel
        </Button>
        <Button primary onClick={resetPassword}>
          Reset Password
        </Button>
      </Modal.Actions>
    </StyledModal>
  );
};

AdminResetPasswordModal.propTypes = {};

AdminResetPasswordModal.defaultProps = {};

export default AdminResetPasswordModal;
